var exports = {
  "T": "xfd349460--adc3a7--colors",
};

module.exports = exports;
